import { db } from '../../common/config/Firebase';

/**
 * Updates an employee's data in Firestore
 * @param {string} oldDni - Current DNI (document ID)
 * @param {Object} employeeData - Updated employee data
 * @param {string} employeeData.dni - New DNI (if changed)
 * @param {string} employeeData.name - Employee name
 * @param {string} employeeData.password - Employee password
 * @param {string} employeeData.position - Employee position
 * @returns {Promise<void>}
 */
export const updateEmployeeUseCase = async (oldDni, employeeData) => {
    try {
        const { dni, name, password, position } = employeeData;

        // If DNI changed, we need to delete old doc and create new one
        if (oldDni !== dni) {
            // Create new document with new DNI
            await db.collection('employees').doc(dni).set({
                name,
                password,
                position
            });

            // Delete old document
            await db.collection('employees').doc(oldDni).delete();

            console.log(`Employee updated: ${oldDni} -> ${dni}`);
        } else {
            // Just update existing document
            await db.collection('employees').doc(dni).update({
                name,
                password,
                position
            });

            console.log(`Employee updated: ${dni}`);
        }
    } catch (error) {
        console.error('Error updating employee:', error);
        throw error;
    }
};
